import { DnevniPlanEmitovanjaTableRow } from './dnevni-plan-emitovanja-table-row';

export class DnevniPlanEmitovanja {
  public DatumEmitovanja: any;
  public KupacNaziv: string;
  public ProgramNaziv: string;
  public EmisijaNaziv: string;
  public UkupnoTrajanje: number;
  public Tabela: Array<DnevniPlanEmitovanjaTableRow> = new Array<
    DnevniPlanEmitovanjaTableRow
  >();
}



// WEBPACK FOOTER //
// ./src/app/models/DnevniPlanEmitovanja/dnevni-plan-emitovanja.ts